<div class="campana-notificaciones">
  <p-overlay-badge
    [value]="cantidadNoLeidas() > 0 ? '' + cantidadNoLeidas() : ''"
    severity="danger"
    [badgeDisabled]="cantidadNoLeidas() === 0">
    <button pButton
            type="button"
            [class]="'p-button-text p-button-rounded campana-boton' + (cantidadNoLeidas() > 0 ? ' campana-boton--activa' : '')"
            aria-label="Notificaciones"
            (click)="alternarPanel($event, panelNotificaciones)">
      <img src="assets/svg/campana.svg" alt="" class="campana-icono" />
    </button>
  </p-overlay-badge>

  <p-popover #panelNotificaciones styleClass="panel-notificaciones">
    <div class="panel-notificaciones__header">
      <div class="panel-notificaciones__header-izquierda">
        <i class="pi pi-bell panel-notificaciones__header-icono"></i>
        <span class="panel-notificaciones__titulo">Notificaciones</span>
        @if (cantidadNoLeidas() > 0) {
          <span class="panel-notificaciones__contador">{{ cantidadNoLeidas() }}</span>
        }
      </div>
      @if (cantidadNoLeidas() > 0) {
        <button pButton
                type="button"
                label="Marcar todo como leído"
                icon="pi pi-check-circle"
                class="p-button-text p-button-sm panel-notificaciones__btn-limpiar"
                (click)="marcarTodasLeidas()">
        </button>
      }
    </div>

    <div class="panel-notificaciones__lista">
      @for (notificacion of notificacionService.notificaciones(); track notificacion.tipo + (notificacion.datos ?? '')) {
        <button type="button"
                class="panel-notificaciones__item"
                (click)="onClickNotificacion(notificacion, $index, panelNotificaciones)">
          <div class="panel-notificaciones__item-icono">
            <i class="pi pi-check-circle"></i>
          </div>
          <div class="panel-notificaciones__item-contenido">
            <div class="panel-notificaciones__item-titulo">{{ notificacion.titulo }}</div>
            <div class="panel-notificaciones__item-mensaje">{{ notificacion.mensaje }}</div>
          </div>
          @if (notificacion.rutaNavegacion) {
            <i class="pi pi-angle-right panel-notificaciones__item-flecha"></i>
          }
        </button>
      } @empty {
        <div class="panel-notificaciones__vacio">
          <i class="pi pi-bell-slash"></i>
          <span>Sin notificaciones nuevas.</span>
          <span class="panel-notificaciones__vacio-sub">Tus notificaciones aparecerán aquí.</span>
        </div>
      }
    </div>
  </p-popover>
</div>
